export enum BOOKING_TYPE {
  ACCOMMODATION = 'accommodation',
  VEHICLE = 'vehicle',
}
